import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';

export const colorEstadoChip = {
    'Yellow': { isYellow: true },
    'Gray': { isGray: true },
    'Green': { isGreen: true },
    'Red': { isRed: true }
};

export const icon = {
    'success': <DoneIcon sx={{ color: '#fff' }} />,
    'warning': <PriorityHighRoundedIcon sx={{ color: '#fff' }} />,
    'error': <ClearIcon sx={{ color: '#fff' }} />
}